import React, {useEffect, useState} from 'react';

function PostAuthor({ avatarUrl, avatarAlt, name, title, authorBio }: { avatarUrl: string; avatarAlt: string; name: string; title?: string; authorBio?: string }) {

  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    let agent = parseUserAgent(navigator.userAgent);
    setIsSafari(agent);
  }, []);

  const parseUserAgent = (pathname) => {
    const isSafari = /^((?!chrome).)*safari/i.test(pathname);
    return isSafari;
  };

  return (
    <>
    {
      title ? (
        <div className=' flex flex-row'>
           <img className="w-11 h-11 border-2 rounded-full" src={avatarUrl} alt={avatarAlt} loading="lazy" />
           <div className='flex flex-col'>
           <span className='ltr:ml-3 rtl:mr-3 lg:text-2xl text-xl font-bold text-omooma-pink-dark-primary rtl:font-bodyAr'>{name}</span>
           <span className=' ltr:ml-3 rtl:mr-3 text-omooma-dark-grey lg:text-sm text-xs mb-2 rtl:font-bodyAr'>{title}</span>
           </div>
        </div>
      )
      :
      (
        <div className="flex flex-row items-center">
        <img className="w-11 h-11 border-2 rounded-full" src={avatarUrl} alt={avatarAlt} loading="lazy" />
        <div className='flex flex-col items-center'>
        <span className={`ltr:ml-3 rtl:mr-3 font-medium ${isSafari ? 'rtl:font-bodyEn ltr:font-headline' : 'ltr:font-headline rtl:font-bodyAr'}`}>{name}</span>
        </div>
      </div>
      )
    }
     
    </>

  );
}

export default PostAuthor;